import { IconButton } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  selectCanRemoteAccessLeoForSite,
  selectCanRemoteAccessControllerForSite,
  selectSiteList,
} from '../../../features/auth/authSlice';
import {
  handleShowHowToEditReportingDialog,
  handleShowHowToAccessLeoDialog,
  handleShowHowToAccessTerminalModeDialog,
} from '../../../features/view/viewSlice';
import ButtonWithOptionsMenu from '../../Buttons/ButtonWithOptionsMenu';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useMemo } from 'react';

const HelpButton = () => {
  const dispatch = useAppDispatch();
  const siteList = useAppSelector(selectSiteList);

  const canRemoteAccessLeo = useAppSelector((state) =>
    siteList
      .map((siteId) => selectCanRemoteAccessLeoForSite(state, siteId))
      .some((bool) => bool),
  );
  const canRemoteAccessController = useAppSelector((state) =>
    siteList
      .map((siteId) => selectCanRemoteAccessControllerForSite(state, siteId))
      .some((bool) => bool),
  );

  const buttonMenuOptions = useMemo((): Array<{
    label: string;
    onClick: () => void;
  }> => {
    const buttonMenuOptions: Array<{ label: string; onClick: () => void }> = [
      {
        label: 'How to Update Email Notfications',
        onClick: () => dispatch(handleShowHowToEditReportingDialog()),
      },
    ];

    if (canRemoteAccessLeo) {
      buttonMenuOptions.push({
        label: 'How to Connect to a LEO Facility Manager',
        onClick: () => dispatch(handleShowHowToAccessLeoDialog()),
      });
    }

    if (canRemoteAccessController) {
      buttonMenuOptions.push({
        label: 'How to Connect to a Controller',
        onClick: () => dispatch(handleShowHowToAccessTerminalModeDialog()),
      });
    }

    return buttonMenuOptions;
  }, [canRemoteAccessController, canRemoteAccessLeo, dispatch]);

  return (
    <ButtonWithOptionsMenu
      renderButton={({ onClick, ref }) => (
        <IconButton onClick={onClick} ref={ref}>
          <HelpOutlineIcon />
        </IconButton>
      )}
      options={buttonMenuOptions}
      zIndex={2}
      dividers
    />
  );
};

export default HelpButton;
